// inverse of ../to/lengthControlToDto
export default function dtoToLengthControl(lengthControl) {
    if (lengthControl === undefined) {
        return undefined;
    }
    return {
        character: lengthControl.character,
        length: lengthControl.length.toString(),
        direction: lengthControl.direction,
        truncate: lengthControl.truncate,
    };
}
